module.exports = __webpack_public_path__ + "static/img/faceRecognition.2cee899a.png";